import React, {useState} from 'react';


const useTabPanel = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    return {value, handleChange, setValue};
};

export default useTabPanel;
